var _linearGradient, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 49"
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "listing_svg__a",
  x1: 24,
  x2: 24,
  y1: 17.5,
  y2: 29.887,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d2dcea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f8fafc"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 47,
  x: 0.5,
  y: 1,
  fill: "#f8fafc",
  rx: 3.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 47,
  x: 0.5,
  y: 1,
  stroke: "#f1f5f9",
  rx: 3.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#cbd5e1",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#listing_svg__a)",
  d: "M16 31.5v-6.773a3 3 0 0 1 1.264-2.446l5-3.549a3 3 0 0 1 3.472 0l5 3.549A3 3 0 0 1 32 24.727V31.5a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 21.5 8.28-5.796a3 3 0 0 1 3.44 0L34 21.5"
}))));
export { SvgListing as ReactComponent };
export default __webpack_public_path__ + "542c47c60d18f9ca9cfc21d918f3d8e2.svg";